import React, { useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import imageCompression from "browser-image-compression";
import { Avatar, Box, Typography } from "@mui/material";
import api from "../../api/axios";

const VendorLogoUploader = ({ vendorLogo, setVendorLogo, setLogoFile, vendorName }) => {

  const onDrop = useCallback(async (acceptedFiles) => {

    const file = acceptedFiles[0];
    if (!file) return;

    const compressedFile = await imageCompression(file, {
      maxSizeMB: 0.5,
      maxWidthOrHeight: 512,
      useWebWorker: true
    });

    const preview = URL.createObjectURL(compressedFile);

    setVendorLogo(preview);
    setLogoFile(compressedFile);   // 🔥 store file for later upload

  }, [setVendorLogo, setLogoFile]);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: { "image/*": [] },
    multiple: false
  });

  const getInitials = (name = "") => {
    if (!name) return "V";
    const words = name.split(" ");
    if (words.length === 1) return words[0][0].toUpperCase();
    return (words[0][0] + words[1][0]).toUpperCase();
  };

  return (
    <Box {...getRootProps()} textAlign="center" sx={{ cursor: "pointer" }}>

      <input {...getInputProps()} />

      <Avatar
        src={vendorLogo || undefined}
        sx={{
          width: 90,
          height: 90,
          mx: "auto",
          fontSize: 30,
          bgcolor: vendorLogo ? "transparent" : "#ff9900"
        }}
      >
        {!vendorLogo && getInitials(vendorName)}
      </Avatar>

      <Typography variant="caption">
        Drag & drop logo or click
      </Typography>

    </Box>
  );
};

export default VendorLogoUploader;